import { useRecoilValue } from "recoil";

import { InFlightClipsAtom } from "MVVM/State/clipStatus";
import type { ClipStatusTimeline } from "MVVM/Components/ClipStatus/@types";
import {
  isTimelineComplete,
  isTimelineErrored,
  isTimelineStale,
} from "MVVM/Components/ClipStatus/timelineDisplay";

// A montage or VOD parent row does no work itself; its child clips do, and
// they carry a montageId. The tray's poller treats it as terminal too.
const isGroupParent = (timeline: ClipStatusTimeline) =>
  ["MONTAGE", "FULL_MATCH_VOD"].includes(timeline.contentType ?? "") &&
  !timeline.montageId;

// TERMINAL_STATES omits COMPLETED_DESKTOP, so the tray's own test is used
// instead. Stale counts as done: 35 minutes silent means it is not coming back.
export const isActiveTimeline = (timeline: ClipStatusTimeline) =>
  !isGroupParent(timeline) &&
  !isTimelineComplete(timeline) &&
  !isTimelineErrored(timeline) &&
  !isTimelineStale(timeline);

// Reads the atom ClipStatusTray already keeps populated, so no extra request.
export const useActiveClips = () => {
  const inFlight = useRecoilValue(InFlightClipsAtom);
  return inFlight.filter(isActiveTimeline);
};
